import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import napaicpLogo from '@/assets/napaicp-logo.png'

export function SiteFooter() {
  const { t } = useTranslation(['common', 'nav'])
  const year = new Date().getFullYear()

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <Link to="/" className="flex items-start gap-3 hover:text-foreground">
          <img src={napaicpLogo} alt="" className="size-10 shrink-0" />
          <div>
            <p className="font-medium text-foreground">{t('common:brand')}</p>
            <p>{t('common:siteUrl')}</p>
          </div>
        </Link>
        <p>{t('common:footer.tagline')}</p>
        <p>{t('common:footer.poweredBy')}</p>
      </div>
      <div className="flex flex-col items-start gap-2 sm:items-end">
        <nav aria-label={t('nav:footerNav')} className="flex gap-4">
          <Link className="hover:text-foreground" to="/about">
            {t('nav:about')}
          </Link>
          <Link className="hover:text-foreground" to="/howto">
            {t('nav:howto')}
          </Link>
          <Link className="hover:text-foreground" to="/help">
            {t('nav:helpCenter')}
          </Link>
          <Link className="hover:text-foreground" to="/architecture">
            {t('nav:architecture')}
          </Link>
        </nav>
        <nav aria-label={t('nav:legalNav')} className="flex gap-4">
          <Link className="hover:text-foreground" to="/trust">
            {t('nav:trust')}
          </Link>
          <Link className="hover:text-foreground" to="/privacy">
            {t('nav:privacy')}
          </Link>
          <Link className="hover:text-foreground" to="/terms">
            {t('nav:terms')}
          </Link>
        </nav>
        <p>
          <Trans
            i18nKey="common:footer.copyright"
            values={{ year }}
            components={{ brandLink: <Link to="/" className="hover:text-foreground" /> }}
          />
        </p>
      </div>
    </div>
  )
}
